import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageMeta from '../../components/PageMeta';
import './FAQ.css';

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      category: t('faq.general'),
      questions: [
        { q: t('faq.q1'), a: t('faq.a1') },
        { q: t('faq.q2'), a: t('faq.a2') },
        { q: t('faq.q3'), a: t('faq.a3') },
        { q: t('faq.q4'), a: t('faq.a4') }
      ]
    },
    {
      category: t('faq.forConsumers'),
      questions: [
        { q: t('faq.q5'), a: t('faq.a5') },
        { q: t('faq.q6'), a: t('faq.a6') },
        { q: t('faq.q7'), a: t('faq.a7') },
        { q: t('faq.q8'), a: t('faq.a8') },
        { q: t('faq.q9'), a: t('faq.a9') }
      ]
    },
    {
      category: t('faq.forFarmers'),
      questions: [
        { q: t('faq.q10'), a: t('faq.a10') },
        { q: t('faq.q11'), a: t('faq.a11') },
        { q: t('faq.q12'), a: t('faq.a12') },
        { q: t('faq.q13'), a: t('faq.a13') },
        { q: t('faq.q14'), a: t('faq.a14') }
      ]
    },
    {
      category: t('faq.accountSecurity'),
      questions: [
        { q: t('faq.q15'), a: t('faq.a15') },
        { q: t('faq.q16'), a: t('faq.a16') },
        { q: t('faq.q17'), a: t('faq.a17') }
      ]
    },
    {
      category: t('faq.ordersPayments'),
      questions: [
        { q: t('faq.q18'), a: t('faq.a18') },
        { q: t('faq.q19'), a: t('faq.a19') },
        { q: t('faq.q20'), a: t('faq.a20') }
      ]
    }
  ];

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <PageMeta
        title={t('faq.title')}
        description={t('faq.subtitle')}
        path="/faq"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="faq-hero-container">
          <h1 className="faq-hero-title">{t('faq.title')}</h1>
          <p className="faq-hero-subtitle">
            {t('faq.subtitle')}
          </p>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="faq-content-section">
        <div className="faq-container">
          {faqs.map((category, categoryIndex) => (
            <div key={categoryIndex} className="faq-category">
              <h2 className="faq-category-title">{category.category}</h2>
              <div className="faq-questions">
                {category.questions.map((item, questionIndex) => {
                  const index = `${categoryIndex}-${questionIndex}`;
                  const isOpen = openIndex === index;
                  
                  return (
                    <div key={questionIndex} className="faq-item">
                      <button
                        className={`faq-question ${isOpen ? 'open' : ''}`}
                        onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                      >
                        <span>{item.q}</span>
                        <span className="faq-icon">{isOpen ? '−' : '+'}</span>
                      </button>
                      {isOpen && (
                        <div className="faq-answer">
                          <p>{item.a}</p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="faq-contact-section">
        <div className="faq-container">
          <div className="faq-contact-box">
            <h2>{t('faq.stillQuestions')}</h2>
            <p>{t('faq.cantFind')}</p>
            <div className="faq-contact-actions">
              <Link to="/contact" className="btn-contact-support">{t('faq.contactSupport')}</Link>
              <Link to="/guides" className="btn-contact-support btn-contact-guides">{t('faq.browseGuides')}</Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQ;

